import { Settlement } from '@app/store/slices/settlements/settlementsTypes';

export interface BannerButton {
  text: string;
  onClick: () => void;
}

interface BannerBase {
  img: string;
  soon?: boolean;
}

export type BannerText = BannerBase & {
  variant: 'text';
  text?: { title?: string; description?: string };
  button?: BannerButton;
};

export type BannerPlaceholder = BannerBase & {
  variant: 'placeholder';
  placeholder: string;
  button?: BannerButton;
};

export type WhatIsDom = BannerBase & {
  variant: 'what_is_dom';
};

export type HomeBanner = BannerText | BannerPlaceholder | WhatIsDom;

export interface SettlementModalState {
  isOpen: boolean;
  settlement?: Settlement;
  action?: SettlementModalAction;
  isBoosting?: boolean;
}

export type SettlementModalAction = 'buy' | 'boost';

export enum FeedPandaType {
  FEED = 'feed',
  FEED_SUCCESS = 'feed_success',
}

export interface FeedPandaModalState {
  isOpen: boolean;
  type?: FeedPandaType;
}
